import { toast } from "react-toastify";
import {
  errorToastStyle,
  successToastStyle,
} from "../../Shared/Utils/ToastUtils";
import {
  getProfileDataFromServer,
  UpdateProfileDataFromServer,
  updateProfilePhotoToServer,
  deleteProfilePhotoFromServer,
} from "../../Services/ProfileSettingService";
import { TokenDecrypt } from "../../Shared/Utils/encryptionDecryption";
export const FETCH_PROFILE_DETAILS = "FETCH_PROFILE_DETAILS";
export const FETCH_PROFILE_DETAILS_SUCCESS = "FETCH_PROFILE_DETAILS_SUCCESS";
export const FETCH_PROFILE_DETAILS_FAILURE = "FETCH_PROFILE_DETAILS_FAILURE";
export const ONCHANE_PROFILE_DETAILS = "ONCHANE_PROFILE_DETAILS";
export const UPDATE_PROFILE = "UPDATE_PROFILE";
export const UPDATE_PROFILE_SUCCESS = "UPDATE_PROFILE_SUCCESS";
export const UPDATE_PROFILE_FAILURE = "UPDATE_PROFILE_FAILURE";
export const UPDATE_PROFILE_PHOTO = "UPDATE_PROFILE_PHOTO";
export const UPDATE_PROFILE_PHOTO_SUCCESS = "UPDATE_PROFILE_PHOTO_SUCCESS";
export const UPDATE_PROFILE_PHOTO_FAILURE = "UPDATE_PROFILE_PHOTO_FAILURE";
export const DELETE_PROFILE_PHOTO = "DELETE_PROFILE_PHOTO";
export const DELETE_PROFILE_PHOTO_SUCCESS = "DELETE_PROFILE_PHOTO_SUCCESS";
export const DELETE_PROFILE_PHOTO_FAILURE = "DELETE_PROFILE_PHOTO_FAILURE";

export const onChaneProfileDetails = (formObj) => {
  return (dispatch) => {
    dispatch({ type: ONCHANE_PROFILE_DETAILS, payload: formObj });
  };
};

export const fetchProfileData = (selectedLanguageID) => {
  return (dispatch) => {
    dispatch({ type: FETCH_PROFILE_DETAILS });
    getProfileDataFromServer(selectedLanguageID)
      .then((response) => {
        dispatch({
          type: FETCH_PROFILE_DETAILS_SUCCESS,
          payload: TokenDecrypt(response.data),
        });
      })
      .catch((error) => {
        dispatch({ type: FETCH_PROFILE_DETAILS_FAILURE, error: error.message });
      });
  };
};
const SuccessfullyPro = "Profile updated successfully";
export const updateProfileDetails = (
  { email },
  emailfromselector,
  fileInputDisabled,
  selectedImage,
  deleteFlag,
  selectedLanguageId
) => {
  return (dispatch) => {
    dispatch({ type: UPDATE_PROFILE });

    const data = {};
    if (email) {
      data.emailaddress = email;
    } else {
      data.emailaddress = emailfromselector;
    }
    UpdateProfileDataFromServer(data)
      .then((response) => {
        dispatch({ type: UPDATE_PROFILE_SUCCESS, payload: data });

        if (deleteFlag === true) {
          dispatch({ type: DELETE_PROFILE_PHOTO });
          deleteProfilePhotoFromServer()
            .then((response) => {
              dispatch({ type: DELETE_PROFILE_PHOTO_SUCCESS });

              toast.success(SuccessfullyPro, {
                style: successToastStyle,
              });
              dispatch(fetchProfileData(selectedLanguageId));
            })
            .catch((error) => {
              // Dispatch failure action if there's an error
              dispatch({
                type: DELETE_PROFILE_PHOTO_FAILURE,
                error: error.message,
              });
              toast.error("Failed to Delete profile photo", {
                style: errorToastStyle,
              });
            });
        }

        if (
          selectedImage !== undefined &&
          fileInputDisabled === false &&
          selectedImage !== null
        ) {
          const formData = new FormData();
          formData.append("file", selectedImage);
          formData.forEach((value, key) => {
            console.log(key, value);
          });
          updateProfilePhotoToServer(formData)
            .then((photoResponse) => {
              dispatch({
                type: UPDATE_PROFILE_PHOTO_SUCCESS,
                payload: selectedImage,
              });
              toast.success(SuccessfullyPro, {
                style: successToastStyle,
              });
              dispatch(fetchProfileData(selectedLanguageId));
            })
            .catch((photoError) => {
              dispatch({
                type: UPDATE_PROFILE_PHOTO_FAILURE,
                error: photoError.message,
              });
              toast.error("Failed to update profile photo", {
                style: errorToastStyle,
              });
            });
        }

        if (deleteFlag !== true && selectedImage === undefined) {
          toast.success(SuccessfullyPro, {
            style: successToastStyle,
          });
        }
      })
      .catch((error) => {
        dispatch({ type: UPDATE_PROFILE_FAILURE, error: error.message });
        toast.error("Failed to update profile", {
          style: errorToastStyle,
        });
        dispatch({
          type: UPDATE_PROFILE_PHOTO_FAILURE,
          error: "Profile update failed. Photo update cancelled.",
        });
      });
  };
};
